import { useTranslation } from "react-i18next";

import BaseHeader from "@/components/Header/BaseHeader";
import HeaderButtons from "@/components/Header/InterventionTemplate";
import { TAB_KEYS } from "@/constants/TabKeys";
import {
  INTERVENTION_TEMPLATE_INCLUDES,
  useGetInterventionTemplate,
} from "@/entities/intervention-template";
import TemplateEditor from "@/features/InterventionTemplates/Details/TemplateEditor";
import { AppLayoutPage } from "@/modules/app-layout/app-layout-page";
import { AppSaveBar } from "@/modules/app-save-bar";
import {
  INTERVENTION_TEMPLATE_JSON_EDITOR_SCOPE,
  InterventionTemplateJsonEditor,
} from "@/modules/intervention-template/intervention-template-json-editor";
import { PageItemGate } from "@/modules/page-item-gate";
import { useIdParam } from "@/services/router";
import { TabView } from "@/ui/tab-view";

const Details = () => {
  const { t } = useTranslation();
  const id = useIdParam();

  const includes = [
    INTERVENTION_TEMPLATE_INCLUDES.REVISION,
    INTERVENTION_TEMPLATE_INCLUDES.REFERENCE_REVISION,
  ].join(",");

  const { template, isLoading, error } = useGetInterventionTemplate(id, {
    params: {
      include: includes,
    },
  });

  const tabs = [
    {
      key: TAB_KEYS.TEMPLATE_EDITOR,
      label: t("form:templateEditor"),
      children: <TemplateEditor template={template} loading={isLoading} />,
    },
    {
      key: TAB_KEYS.TEMPLATE_JSON,
      label: t("form:jsonEditor"),
      children: <InterventionTemplateJsonEditor template={template} />,
      fullHeight: true,
    },
  ];

  return (
    <PageItemGate model="interventiontemplate" queryError={error}>
      <BaseHeader
        title={template?.name}
        loading={isLoading}
        extra={
          !isLoading && [
            <HeaderButtons key="HeaderButtons" template={template} />,
          ]
        }
      />
      <AppLayoutPage>
        <TabView
          isNav
          isFullHeight
          tabs={tabs}
          defaultActiveKey={TAB_KEYS.TEMPLATE_EDITOR}
          tabBarExtraContent={
            <AppSaveBar
              scope={INTERVENTION_TEMPLATE_JSON_EDITOR_SCOPE}
              tabs={[TAB_KEYS.TEMPLATE_JSON]}
              date={template?.updated_at}
              loading={isLoading}
            />
          }
        />
      </AppLayoutPage>
    </PageItemGate>
  );
};

export default Details;
